import { useEffect, useState } from 'react';
import useAxios from './useAxios';

const useVCmsContent = id => {
    const [vcmsContent, setVcmsContent] = useState();
    const { get } = useAxios();

    useEffect(() => {
        (async () => {
            if (id) {
                try {
                    const response = await get(`/api/vcms/GetMedia?publicId=${id}`);

                    if (response) {
                        setVcmsContent(response);
                    }
                } catch (e) {
                    console.error(`Error fetching VCMS content - ${e.message}`);
                }
            }
        })();
    }, [get, id]);

    return vcmsContent;
};

export default useVCmsContent;
